/**
 * InterestingFacts Widget
 */
import React from 'react';
import { Row, Col } from 'reactstrap';

function InterestingFacts() {

    return (
        <div className="section-wrapper section-ptb bg-gray">
                <div className="container">
                <Row>
                    <Col sm={12}>
                    <div className="section-title text-center">
                        <h2 className="font-bold title">Interesting Facts</h2>
                        <p className="text-center">Discover the best collection for autumn of Stylist Art. With so
                        charming, modern and passionate, you certainly love this collection.</p>
                    </div>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col lg={4} md={6}>
                    <div className="mb-4 mb-md-6 mt-4 mt-md-6 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-right magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-right info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-exchange" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    01 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                Free exchanges </h4>
                                <div className="magasin_info_box-description">
                                <p>If something isn't your cup of tea then you can simply swap it
                                    for another experience.</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="mb-4 mb-md-6 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-right magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-right info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-retweet" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    02 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                60 Day refund policy </h4>
                                <div className="magasin_info_box-description">
                                <p>Plenty of time to change your mind odio dignissimos ducimus qui
                                    blanditiis praesentium.</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="mb-4 mb-md-6 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-right magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-right info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-inbox" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    03 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                E-vouchers to inbox </h4>
                                <div className="magasin_info_box-description">
                                <p>Sent straight to your inbox within 2 hours many desktop
                                    publishing packages.</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </Col>
                    <Col sm={4} className="d-none d-lg-block">
                    <img src={require(`../assets/images/about-us-1.png`)} className="img-fluid" />
                    </Col>
                    <Col lg={4} md={6}>
                    <div className="mb-4 mb-md-6 mt-0 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-left magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-left info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix left-info-icon-bottom">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-gift" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    04 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                Premium Gifts </h4>
                                <div className="magasin_info_box-description">
                                <p>Upgrade for £3.50 It has survived not only five centuries, but
                                    also the leap into electronic.</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="mb-4 mb-md-6 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-left magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-left info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix left-info-icon-bottom">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-usd" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    05 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                Best price guarantee </h4>
                                <div className="magasin_info_box-description">
                                <p>We want to make sure you get the best deals on the web at vero
                                    eos et accusamus</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="mb-0 mb-md-6 magasin_info_box magasin_info_box-layout-style_2 magasin_info_box-content_alignment-left magasin_info_box-with-icon magasin_info_box-icon-source-font magasin_info_box-icon-style-border magasin_info_box-icon-size-md magasin_info_box-icon-shape-round magasin_info_box-icon_position-left info_box-step_position-above_title">
                        <div className="magasin_info_box-inner clearfix left-info-icon-bottom">
                        <div className="magasin_info_box-icon">
                            <div className="magasin_info_box-icon-wrap">
                            <div className="magasin_info_box-icon-outer">
                                <div className="magasin_info_box-icon-inner" style={{borderColor: '#04d39f', borderWidth: '2px', borderStyle: 'solid'}}>
                                <i className="fa fa-truck" style={{color: '#04d39f'}} /> </div>
                            </div>
                            </div>
                        </div>
                        <div className="magasin_info_box-content">
                            <div className="magasin_info_box-content-wrap">
                            <div className="magasin_info_box-content-inner">
                                <div className="magasin_info_box-step-wrapper">
                                <span className="magasin_info_box-step">
                                    06 </span>
                                </div>
                                <h4 className="magasin_info_box-title" style={{color: '#323232'}}>
                                Ship the same day </h4>
                                <div className="magasin_info_box-description">
                                <p>Order an experience before 3pm and we'll get it in the post the
                                    same day versions have evolved.</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </Col>
                </Row>
                </div>
            </div>
        )

    }

export default InterestingFacts;
